import { Component, OnInit, AfterViewInit, ViewChild, OnDestroy, HostListener } from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import * as $ from 'jquery';

// Service
import { LocalStorageService } from './../../../../services/infrastructure/local-storage.service';
import { BroadcastService } from './../../../../services/infrastructure/broadcaster.service';
import { CommonService } from './../../../../services/common/common.service';
import { LoaderService } from './../../../../services/infrastructure/loader.service';
import { QuickSearchOrderService } from './../../../../services/seed/reports/quick-search-order.service';
import { ExcelService } from './../../../../services/infrastructure/excel.service';

// Other
import { MasterConstants } from '../../../../common/constants/master-constants';
import { Subscription } from 'rxjs';
import { LolLoggerService } from '../../../../common/shared/lol-logger.service';
import { ReportType } from '../../../../models/report-type.model';
import { UserReportFilterSliderService } from '../../../../common/components/user-report-filter/user-report-filter-slider.service';
import { UserFilterColumnDisplayed } from '../../../../models/user-filter-columndisplayed.model';
import { ColumnDescription, UserReportFilter } from '../../../../models/user-report-filter.model';
import { UserReportFilterService } from '../../../../services/seed/reports/user-report-filter.service';

@Component({
  selector: 'app-quick-order-search',
  templateUrl: './quick-order-search.component.html',
  styleUrls: ['./quick-order-search.component.scss'],
  providers: [QuickSearchOrderService]
})

export class QuickOrderSearchComponent implements OnInit, AfterViewInit, OnDestroy {
  private subscription = new Array<Subscription>();
  private originalDisplayedColumns: any[];

  public currentFilter = new UserReportFilter();

  headerYear: any;
  headerCompany = MasterConstants.US_COMPANYCODE;
  searchValue = '';
  selectedValue: string;
  filterList: any;
  productList: any;
  accountId: number;
  validateEvolveData: any;
  previousSelectedValue: string;
  isEvolveAccountRestriction = false;
  partialSearchValue = '';
  isTextBoxEmpty = true;
  export: boolean;
  pageName = 'QuickOrder';
  filterValueList = new Array();

  marketingMasterList: any = [];
  seedsizeMasterList: any = [];
  districtMasterList: any = [];
  packagesizeMasterList: any = [];
  treatmentMasterList: any = [];
  productLineMasterList: any = [];
  stateMasterList: any = [];
  accountNoList: any = [];
  userIdList: any = [];
  orderNoList: any = [];
  totalRecords = 0;
  orderTypeList: any = [{ id: 'Dealer Order', value: 'Dealer Order' }, { id: 'Grower Order', value: 'Grower Order' }];
  isEaUnitsEligible: boolean = false;
  filter: QuickSearchFilter = new QuickSearchFilter();

  searchTypeList: string[] = ['Product Name', 'Marketing Brand', 'Product Line', 'Seed Size', 'Package Size', 'Treatment', 'Item Number', 'Parent Account No',
    'Account No', 'Account Name', 'WFU Employee', 'City', 'State/ Province', 'User ID', 'Order Type', 'Order No'];

  // HTML Table
  headerDS: any[];
  bodyDS: any[] = [];
  paginatorDS: any[] = [];

  // MatPaginator Inputs
  length = 0;
  pageSize = 50;
  pageIndex = 0;
  pageSizeOptions: number[] = [5, 10, 25, 50];

  salesGenericLevel: any;
  impDisplayName: any;

  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private broadcastService: BroadcastService,
    private localStorageService: LocalStorageService,
    private commonService: CommonService,
    private loaderService: LoaderService,
    private quickSearchOrderService: QuickSearchOrderService,
    private excelService: ExcelService,
    private toastrService: ToastrService,
    private activatedRoute: ActivatedRoute,
    private userReportFilterSliderService: UserReportFilterSliderService,
    private userReportFilterService: UserReportFilterService) {
  }

  // OnInit
  ngOnInit() {
    if (this.activatedRoute.snapshot.data['evoleAccess']) {
    }
    if (this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR)) {
      this.headerYear = JSON.parse(this.localStorageService.get(MasterConstants.HEADER_CROP_YEAR));
    }

    if (this.localStorageService.get(MasterConstants.WF_Sales_GenericLevel)) {
      this.salesGenericLevel = JSON.parse(this.localStorageService.get(MasterConstants.WF_Sales_GenericLevel));
      this.impDisplayName = this.salesGenericLevel.find(x => x.data == MasterConstants.WF_Impl_SplList_Display).value;
    }

    if (this.localStorageService.get(MasterConstants.EVOLVE_ACCESS)) {
      this.validateEvolveData = JSON.parse(this.localStorageService.get(MasterConstants.EVOLVE_ACCESS));
    }
    this.isEaUnitsEligible = JSON.parse(this.localStorageService.get(MasterConstants.SEED_EA_ACCESS)) ? true : false;

    if (this.isEaUnitsEligible == true) {
      this.originalDisplayedColumns = [
        { headertxt: "Order Number", columnfield: "orderNumber", className: 'mat-header-cell orderNumber text-center', tdClassName: 'mat-cell orderNoText text-center' },
        { headertxt: "Order Type", columnfield: "orderType", className: 'mat-header-cell orderType text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Item Number", columnfield: "itemNumber", className: 'mat-header-cell itemNumber text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "GTIN", columnfield: "gtin", className: 'mat-header-cell itemNumber text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Product Name", columnfield: "productName", className: 'mat-header-cell itemNumber text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Seed Size", columnfield: "seedSize", className: 'mat-header-cell seedSize text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Treatment", columnfield: "treatment", className: 'mat-header-cell treatment text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Package Size", columnfield: "packageSize", className: 'mat-header-cell packageSize text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Long/(Short)", columnfield: "longShort", className: 'mat-header-cell longShort text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "MDB", columnfield: "mdbUnits", className: 'mat-header-cell quantity text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Equiv Units(BG)", columnfield: "quantity", className: 'mat-header-cell quantity text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "In Progress(Soft+Hard)", columnfield: "inProgressQty", className: 'mat-header-cell inProgressQty text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Shipped/Invoiced", columnfield: "shippedInvoicedQty", className: 'mat-header-cell shippedInvoicedQty text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Left to Process", columnfield: "leftToProcess", className: 'mat-header-cell shippedInvoicedQty text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Left to Invoice", columnfield: "leftToInvoiced", className: 'mat-header-cell inProgressQty text-center', tdClassName: 'mat-cell text-center' },
        //{ headertxt: "EA Units", columnfield: "eaUnits", className: 'mat-header-cell inProgressQty text-center', tdClassName: 'mat-cell text-center' },
        //{ headertxt: "EA Units Remaining", columnfield: "eaUnitsRemaining", className: 'mat-header-cell inProgressQty text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Desired Delivery Date", columnfield: "desiredDeliveryDate", className: 'mat-header-cell desiredDeliveryDate text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Grower Business Name", columnfield: "growerBusinessName", className: 'mat-header-cell growerBusinessName text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Grower Name", columnfield: "growerName", className: 'mat-header-cell growerName text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "GLN", columnfield: "gln", className: 'mat-header-cell growerName text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Parent Account", columnfield: "parentNo", className: 'mat-header-cell parentNo text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Account", columnfield: "accountNumber", className: 'mat-header-cell accountNumber text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Account Name", columnfield: "accountName", className: 'mat-header-cell accountName text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Account City", columnfield: "city", className: 'mat-header-cell city text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Account State", columnfield: "state", className: 'mat-header-cell state text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Account Zip", columnfield: "zipCode", className: 'mat-header-cell state text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Marketing Brand", columnfield: "marketingBrand", className: 'mat-header-cell marketingBrand text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Product Line", columnfield: "productLine", className: 'mat-header-cell marketingBrand text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Seller Name", columnfield: "sellerName", className: 'mat-header-cell sellerName text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: this.impDisplayName , columnfield: "implementationSpecialist", className: 'mat-header-cell dsm text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Account Manager", columnfield: "accountManager", className: 'mat-header-cell dsm text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Sales Enablement/CDS", columnfield: "salesEnablement", className: 'mat-header-cell dsm text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "ASM/BU Lead", columnfield: "buLead", className: 'mat-header-cell rsd text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "SE/CDS Lead", columnfield: "cdsLead", className: 'mat-header-cell rsd text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Seed Execution Lead", columnfield: "selAccountName", className: 'mat-header-cell rsd text-center', tdClassName: 'mat-cell text-center pl-0' }
      ];
    }
    else {
      this.originalDisplayedColumns = [
        { headertxt: "Order Number", columnfield: "orderNumber", className: 'mat-header-cell orderNumber text-center', tdClassName: 'mat-cell orderNoText text-center' },
        { headertxt: "Order Type", columnfield: "orderType", className: 'mat-header-cell orderType text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Item Number", columnfield: "itemNumber", className: 'mat-header-cell itemNumber text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "GTIN", columnfield: "gtin", className: 'mat-header-cell itemNumber text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Product Name", columnfield: "productName", className: 'mat-header-cell itemNumber text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Seed Size", columnfield: "seedSize", className: 'mat-header-cell seedSize text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Treatment", columnfield: "treatment", className: 'mat-header-cell treatment text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Package Size", columnfield: "packageSize", className: 'mat-header-cell packageSize text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Long/(Short)", columnfield: "longShort", className: 'mat-header-cell longShort text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "MDB", columnfield: "mdbUnits", className: 'mat-header-cell quantity text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Equiv Units(BG)", columnfield: "quantity", className: 'mat-header-cell quantity text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "In Progress(Soft+Hard)", columnfield: "inProgressQty", className: 'mat-header-cell inProgressQty text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Shipped/Invoiced", columnfield: "shippedInvoicedQty", className: 'mat-header-cell shippedInvoicedQty text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Left to Process", columnfield: "leftToProcess", className: 'mat-header-cell shippedInvoicedQty text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Left to Invoice", columnfield: "leftToInvoiced", className: 'mat-header-cell inProgressQty text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Desired Delivery Date", columnfield: "desiredDeliveryDate", className: 'mat-header-cell desiredDeliveryDate text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Grower Business Name", columnfield: "growerBusinessName", className: 'mat-header-cell growerBusinessName text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Grower Name", columnfield: "growerName", className: 'mat-header-cell growerName text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "GLN", columnfield: "gln", className: 'mat-header-cell growerName text-center', tdClassName: 'mat-cell text-center' },
        { headertxt: "Parent Account", columnfield: "parentNo", className: 'mat-header-cell parentNo text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Account", columnfield: "accountNumber", className: 'mat-header-cell accountNumber text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Account Name", columnfield: "accountName", className: 'mat-header-cell accountName text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Account City", columnfield: "city", className: 'mat-header-cell city text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Account State", columnfield: "state", className: 'mat-header-cell state text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Account Zip", columnfield: "zipCode", className: 'mat-header-cell state text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Marketing Brand", columnfield: "marketingBrand", className: 'mat-header-cell marketingBrand text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Product Line", columnfield: "productLine", className: 'mat-header-cell marketingBrand text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Seller Name", columnfield: "sellerName", className: 'mat-header-cell sellerName text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: this.impDisplayName, columnfield: "implementationSpecialist", className: 'mat-header-cell dsm text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Account Manager", columnfield: "accountManager", className: 'mat-header-cell dsm text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Sales Enablement/CDS", columnfield: "salesEnablement", className: 'mat-header-cell dsm text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "ASM/BU Lead", columnfield: "buLead", className: 'mat-header-cell rsd text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "SE/CDS Lead", columnfield: "cdsLead", className: 'mat-header-cell rsd text-center', tdClassName: 'mat-cell text-center pl-0' },
        { headertxt: "Seed Execution Lead", columnfield: "selAccountName", className: 'mat-header-cell rsd text-center', tdClassName: 'mat-cell text-center pl-0' }
      ];
    }
    this.headerDS = this.originalDisplayedColumns;

    if (this.validateEvolveData != undefined) {
      const sessionData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
      this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;
      if (sessionData.evolveAccountRestriction && (sessionData.userIdRole === 'WURegionalSalesDirector' || sessionData.userIdRole === 'WUSeedExecutionLead')) {
        this.searchTypeList = ['Product Name', 'Marketing Brand', 'WFU Employee', 'Product Line', 'Seed Size', 'Package Size',
          'Treatment', 'Item Number', 'Parent Account No', 'Account No', 'Account Name', 'City', 'State/ Province', 'Order Type', 'Order No'];
      }
      else if (sessionData.evolveAccountRestriction && (sessionData.userIdRole !== 'WURegionalSalesDirector' || sessionData.userIdRole !== 'WUSeedExecutionLead')) {
        this.searchTypeList = ['Product Name', 'Marketing Brand', 'Product Line', 'Seed Size', 'Package Size',
          'Treatment', 'Item Number', 'Parent Account No', 'Account No', 'Account Name', 'City', 'State/ Province', 'Order Type', 'Order No'];
      }
    }

    this.loadMasterData();
    this.resetFilter();
    this.selectedValue = this.searchTypeList[0];

    this.subscription.push(
      this.userReportFilterSliderService.selectedUserFilter.subscribe(filter => {
        if (filter && filter.reportFilter) {
          this.resetFilter();
          this.currentFilter = filter;
          const filters: UserFilterColumnDisplayed = JSON.parse(filter.reportFilter);
          this.filterList = filters.filterOption;

          let filterHeader = []
          filters.displayedColumns.forEach(d => {
            let displayColumn = this.originalDisplayedColumns.filter(x => x.columnfield == d.columnfield);
            if (displayColumn && displayColumn[0]) {
              //fix column at first position
              if (displayColumn[0].columnfield == 'orderNumber') {
                filterHeader.unshift(displayColumn[0]);
              }
              else {
                filterHeader.push(displayColumn[0]);
              }
            }
          });
          this.headerDS = filterHeader;
          this.getFilterData();
        }
        else {
          if (filter && filter.filterDescription === this.currentFilter.filterDescription || !filter)
            this.currentFilter = new UserReportFilter();
        }
      }));
  }

  ngOnDestroy() {
    this.userReportFilterSliderService.resetFilter();

    this.subscription.forEach(subscription => subscription.unsubscribe());
  }

  // To remove clear search filter
  removeProductFilter(filterValue) {
    const removeFilter = filterValue.split(' : ');
    const index = -1;
    switch (removeFilter[0].trim()) {
      case 'Product Name':
        this.filterList.Brand = null;
        this.filter.productName = null;
        break;
      case 'Marketing Brand':
        this.filterList.MarketingBrandList = [];
        this.filter.marketingBrand = null;
        break;
      case 'District':
        this.filterList.DistrictList = [];
        this.filter.district = null;
        break;
      case 'Product Line':
        this.filterList.ProductLineList = [];
        this.filter.productLine = null;
        break;
      case 'Seed Size':
        this.filterList.SeedSizeList = [];
        this.filter.seedSize = null;
        break;
      case 'Package Size':
        this.filterList.PackageSizeList = [];
        this.filter.packageSize = null;
        break;
      case 'Treatment':
        this.filterList.TreatmentList = [];
        this.filter.treatment = null;
        break;
      case 'Parent Account No':
        this.filterList.ParentNo = null;
        this.filter.parentNo = null;
        break;
      case 'Account No':
        if (this.isEvolveAccountRestriction) {
          this.filterList.AccountNo = [];
        }
        else {
          this.filterList.TxtAccountNo = null;
        }
        this.filterList.AccountNo = [];
        this.filter.account = null;
        break;
      case 'Account Name':
        this.filterList.AccountName = null;
        this.filter.accountName = null;
        break;
      case 'Item Number':
        this.filterList.ItemNoList = [];
        this.filter.itemNo = null;
        break;
      case 'User Id':
        this.filterList.UserId = [];
        this.filter.userID = null;
        break;
      case 'Order No':
        this.filterList.OrderId = null;
        this.filter.orderNumber = null;
        break;
      case 'City':
        this.filterList.City = null;
        this.filter.city = null;
        break;
      case 'State':
        this.filterList.State = [];
        this.filter.state = null;
        break;
      case 'Order Type':
        this.filterList.OrderTypeList = [];
        this.filter.orderType = null;
        break;
      default:
        break;
    }
  }

  // Enable disable search
  enableDisableSearch() {
    if (this.validateProductFilter(this.filterList)) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  // Validate Product search
  validateProductSearch() {
    // To Validate Brand
    if (this.filterList.Brand !== null && this.filterList.Brand !== '' && this.filterList.Brand.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    // To Validate City
    else if (this.filterList.City !== null && this.filterList.City !== '' && this.filterList.City.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    // To Validate Account Name
    else if (this.filterList.AccountName !== null && this.filterList.AccountName !== '' && this.filterList.AccountName.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    // To Validate Parent Account Number
    else if (this.filterList.ParentNo !== null && this.filterList.ParentNo !== '' && this.filterList.ParentNo.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    // To Validate Order No
    else if (this.filterList.OrderId !== null && this.filterList.OrderId !== '' && this.filterList.OrderId.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    // To Validate text account no
    else if (this.filterList.TxtAccountNo !== null && this.filterList.TxtAccountNo !== '' && this.filterList.TxtAccountNo.toString().trim().length >= 2) {
      this.isTextBoxEmpty = false;
    }
    else {
      this.isTextBoxEmpty = true;
    }
  }

  // Load Master data
  loadMasterData() {
    // get Item Number List
    this.subscription.push(this.commonService.getItemNumbers().subscribe((result: any) => {
      this.orderNoList = result;
    }));

    // SeedSize master data
    if (this.localStorageService.get(MasterConstants.ALL_SEED_SIZE_LIST)) {
      this.seedsizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_SEED_SIZE_LIST));
    }

    // PackageSize master data
    if (this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST)) {
      this.packagesizeMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_PACKAGE_SIZE_LIST));
    }

    // Treatment master data
    if (this.localStorageService.get(MasterConstants.ALL_TREATMENT_LIST)) {
      this.treatmentMasterList = JSON.parse(this.localStorageService.get(MasterConstants.ALL_TREATMENT_LIST));
    }

    // ProductLine master data
    if (this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST)) {
      this.productLineMasterList = JSON.parse(this.localStorageService.get(MasterConstants.PRODUCT_LINE_MASTER_LIST));
    }

    this.subscription.push(this.commonService.getReportFilterDDLValues(this.headerYear).subscribe(result => {
      const data = result as commonDDL;
      this.stateMasterList = data.states;
      this.accountNoList = data.accounts;
      this.districtMasterList = data.distDSM;
      this.userIdList = data.userId;
      this.marketingMasterList = data.marketingBrand;
      this.loaderService.setLoaderStatus(false);
    }, error => { this.loaderService.setLoaderStatus(false); LolLoggerService.error(error); }));
  }

  // Clear filter
  clearFilter(filterValue) {
    const index = this.filterValueList.indexOf(filterValue);
    this.searchValue = '';
    if (index > -1) {
      this.filterValueList.splice(index, 1);
      // remove product filter
      this.removeProductFilter(filterValue);

      if (this.filterValueList.length < 1) {
        // TO Do clear grid data
      }
      this.enableDisableSearch();
      this.setFilterTypeList();
    }
  }

  //Select filter
  public selectFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filterList,
      filterValueList: this.filterValueList
    };

    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.OrderDetailReport, 0, this.originalDisplayedColumns.map(x => new ColumnDescription(x.columnfield, x.headertxt)), newFilter);
  }

  //Add filter
  public addFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filterList,
      filterValueList: this.filterValueList
    };

    let newFilter = new UserReportFilter();

    newFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.OrderDetailReport, 1, this.originalDisplayedColumns.map(x => new ColumnDescription(x.columnfield, x.headertxt)), newFilter);
  }

  public editFilter() {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filterList,
      filterValueList: this.filterValueList,
      displayedColumns: this.headerDS.map(x => new ColumnDescription(x.columnfield, x.headertxt))
    };

    this.currentFilter.reportFilter = JSON.stringify(filters);

    this.userReportFilterSliderService.activeSlider(ReportType.GrowerOrderAudit, 1, this.originalDisplayedColumns.map(x => new ColumnDescription(x.columnfield, x.headertxt)), this.currentFilter);
  }

  public save(): void {
    const filters: UserFilterColumnDisplayed = {
      filterOption: this.filterList,
      filterValueList: this.filterValueList,
      displayedColumns: this.headerDS.map(x => new ColumnDescription(x.columnfield, x.headertxt))
    };

    this.currentFilter.reportFilter = JSON.stringify(filters);

    if (this.currentFilter.userReportFilterId) {
      this.subscription.push(this.userReportFilterService.updateUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.toastrService.success("Records saved successfully.");
        }
      }));
    }
    else {
      this.subscription.push(this.userReportFilterService.addUserReportFilters(this.currentFilter).subscribe(filter => {
        if (filter) {
          this.toastrService.success("Records saved successfully.");
        }
      }));
    }
  }

  // To validate product filter
  validateProductFilter(productFilter) {
    let isValid = false;

    // To Validate Brand
    if (productFilter.Brand !== null && productFilter.Brand !== '' && productFilter.Brand.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate MarketingBrand
    if (productFilter.MarketingBrandList != null && productFilter.MarketingBrandList.length > 0) {
      isValid = true;
    }

    // To Validate District
    if (productFilter.DistrictList != null && productFilter.DistrictList.length > 0) {
      isValid = true;
    }

    // To Validate ProductLine
    if (productFilter.ProductLineList != null && productFilter.ProductLineList.length > 0) {
      isValid = true;
    }

    // To Validate SeedSize
    if (productFilter.SeedSizeList != null && productFilter.SeedSizeList.length > 0) {
      isValid = true;
    }

    // To Validate PackageSize
    if (productFilter.PackageSizeList != null && productFilter.PackageSizeList.length > 0) {
      isValid = true;
    }

    // To Validate Treatment
    if (productFilter.TreatmentList != null && productFilter.TreatmentList.length > 0) {
      isValid = true;
    }

    // To Validate ParentNo
    if (productFilter.ParentNo !== null && productFilter.ParentNo !== '' && productFilter.ParentNo.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate User Id
    if (productFilter.UserId != null && productFilter.UserId.length > 0) {
      isValid = true;
    }

    // To Validate Order No
    if (productFilter.OrderId !== null && productFilter.OrderId !== '' && productFilter.OrderId.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate text Account no
    if (productFilter.TxtAccountNo !== null && productFilter.TxtAccountNo !== '' && productFilter.TxtAccountNo.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate Account No
    if (productFilter.AccountNo != null && productFilter.AccountNo.length > 0) {
      isValid = true;
    }

    // To Validate Account Name
    if (productFilter.AccountName !== null && productFilter.AccountName !== '' && productFilter.AccountName.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate City
    if (productFilter.City !== null && productFilter.City !== '' && productFilter.City.toString().trim().length >= 2) {
      isValid = true;
    }

    // To Validate Item No
    if (productFilter.ItemNoList != null && productFilter.ItemNoList.length > 0) {
      isValid = true;
    }

    // To Validate State
    if (productFilter.State != null && productFilter.State.length > 0) {
      isValid = true;
    }

    // To Validate OrderType
    if (productFilter.orderType != null && productFilter.orderType.length > 0) {
      isValid = true;
    }

    if (productFilter.Brand == null
      && (productFilter.MarketingBrandList == null || productFilter.MarketingBrandList.length <= 0)
      && (productFilter.DistrictList == null || productFilter.DistrictList.length <= 0)
      && (productFilter.ProductLineList == null || productFilter.ProductLineList.length <= 0)
      && (productFilter.SeedSizeList == null || productFilter.SeedSizeList.length <= 0)
      && (productFilter.PackageSizeList == null || productFilter.PackageSizeList.length <= 0)
      && (productFilter.TreatmentList == null || productFilter.TreatmentList.length <= 0)
      && (productFilter.ParentNo == null)
      && (productFilter.UserId == null || productFilter.UserId.length <= 0)
      && productFilter.OrderId == null
      && productFilter.TxtAccountNo == null
      && (productFilter.AccountNo == null || productFilter.AccountNo.length <= 0)
      && productFilter.AccountName == null
      && productFilter.City == null
      && (productFilter.State == null || productFilter.State.length <= 0)
      && (productFilter.orderType == null || productFilter.orderType.length <= 0)
      && (productFilter.ItemNoList == null || productFilter.ItemNoList.length <= 0)
    ) {
      isValid = false;
    }
    return isValid;
  }

  // Clear all filter
  clearAllFilter() {
    this.filterValueList = new Array();
    this.searchValue = '';
    this.productList = new Array();
    this.isTextBoxEmpty = true;
    this.resetFilter();

    const sessionData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
    this.isEvolveAccountRestriction = sessionData.evolveAccountRestriction;
    if (sessionData.evolveAccountRestriction && (sessionData.userIdRole === 'WURegionalSalesDirector' || sessionData.userIdRole === 'WUSeedExecutionLead')) {
      this.searchTypeList = ['Product Name', 'Marketing Brand', 'Product Line', 'Seed Size', 'Package Size',
        'Treatment', 'Item Number', 'Parent Account No', 'Account No', 'Account Name', 'WFU Employee', 'City', 'State/ Province', 'Order Type', 'Order No'];
    }
    else if (sessionData.evolveAccountRestriction && (sessionData.userIdRole !== 'WURegionalSalesDirector' || sessionData.userIdRole !== 'WUSeedExecutionLead')) {
      this.searchTypeList = ['Product Name', 'Marketing Brand', 'Product Line', 'Seed Size', 'Package Size',
        'Treatment', 'Item Number', 'Parent Account No', 'Account No', 'Account Name', 'City', 'State/ Province', 'Order Type', 'Order No'];
    }
    else {
      this.searchTypeList = ['Product Name', 'Marketing Brand', 'Product Line', 'Seed Size', 'Package Size',
        'Treatment', 'Item Number', 'Parent Account No', 'Account No', 'Account Name', 'WFU Employee', 'City', 'State/ Province', 'User ID', 'Order Type', 'Order No'];
    }
    this.currentFilter = new UserReportFilter();
    this.userReportFilterSliderService.resetFilter();
    this.headerDS = this.originalDisplayedColumns.map(x => new ColumnDescription(x.columnfield, x.headertxt));
    // To Do clear data grid
    this.bodyDS = [];
    this.setPaginatorDS();
    this.paginator.firstPage();
  }

  // Reset Product Filter
  resetFilter() {
    this.filterList = {
      'CompanyCode': this.headerCompany,
      'CropYear': this.headerYear,
      'IsAvailabilityChecked': false,
      'Brand': null,
      'City': null,
      'OrderId': null,
      'AccountName': null,
      'TxtAccountNo': null,
      'UserId': [],
      'State': [],
      'AccountNo': [],
      'MarketingBrandList': [],
      'SeedSizeList': [],
      'DistrictList': [],
      'PackageSizeList': [],
      'TreatmentList': [],
      'ParentNo': null,
      'ProductLineList': [],
      'OrderTypeList': [],
      'ItemNoList': [],
    };
  }

  validateInputText() {
    const accountRegx = RegExp('^[0-9, ]+$');
    const orderIdRegx = RegExp('^[a-zA-Z0-9, ]+$');
    const cityRegx = RegExp('^[a-zA-Z0-9, ]+$');

    if (this.filterList.TxtAccountNo && accountRegx.test(this.filterList.TxtAccountNo) == false) {
      this.filterList.TxtAccountNo = null;
      return false;
    } else if (this.filterList.ParentNo && accountRegx.test(this.filterList.ParentNo) == false) {
      this.filterList.ParentNo = null;
      return false;
    } else if (this.filterList.OrderId && orderIdRegx.test(this.filterList.OrderId) == false) {
      this.filterList.OrderId = null;
      return false;
    } else if (this.filterList.City && cityRegx.test(this.filterList.City) == false) {
      this.filterList.City = null;
      return false;
    } else {
      return true;
    }
  }

  // Keep filter values
  keepFilter() {
    if (!this.validateInputText()) {
      this.toastrService.error('Invalid Input.');
      return false;
    }

    if (this.filterValueList) {
      let selectedIds = '';

      // Create filterValueList from Product Filters
      this.filterValueList = [];
      if (this.filterList) {
        // Brand
        if (this.filterList.Brand && this.filterList.Brand != '') {
          this.filterValueList.push('Product Name : ' + this.filterList.Brand);
          this.filter.productName = this.filterList.Brand;
        }
        else {
          this.filter.productName = null;
        }
        // Marketing Brand
        if (this.filterList.MarketingBrandList && this.filterList.MarketingBrandList.length > 0) {
          let strMB = '';
          this.filterList.MarketingBrandList.forEach(x => {
            strMB = strMB + x + ', ';
          });
          this.filterValueList.push('Marketing Brand : ' + strMB.substr(0, strMB.length - 2));

          selectedIds = '';
          this.marketingMasterList.forEach(x => {
            if (this.filterList.MarketingBrandList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.marketingBrand = selectedIds;
        }
        else {
          this.filter.marketingBrand = null;
        }

        // District
        if (this.filterList.DistrictList && this.filterList.DistrictList.length > 0) {
          let strDSM = '';
          this.filterList.DistrictList.forEach(x => {
            strDSM = strDSM + x + ', ';
          });
          this.filterValueList.push('WFU Employee : ' + strDSM.substr(0, strDSM.length - 2));
          var sessionData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
          if (!sessionData.evolveAccountRestriction) {
            this.searchTypeList = ['Product Name', 'Marketing Brand', 'Product Line', 'Seed Size', 'Package Size',
              'Treatment', 'Item Number', 'Parent Account No', 'Account No', 'Account Name', 'WFU Employee', 'City', 'State/ Province', 'Order Type', 'Order No'];
          }

          selectedIds = '';
          this.districtMasterList.forEach(x => {
            if (this.filterList.DistrictList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.district = selectedIds;
        }
        else {
          this.filter.district = null;
        }

        // Product Line
        if (this.filterList.ProductLineList && this.filterList.ProductLineList.length > 0) {
          let strPL = '';
          this.filterList.ProductLineList.forEach(x => {
            strPL = strPL + x + ', ';
          });
          this.filterValueList.push('Product Line : ' + strPL.substr(0, strPL.length - 2));

          selectedIds = '';
          this.productLineMasterList.forEach(x => {
            if (this.filterList.ProductLineList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.productLine = selectedIds;
        }
        else {
          this.filter.productLine = null;
        }

        // Seed Size
        if (this.filterList.SeedSizeList && this.filterList.SeedSizeList.length > 0) {
          let strSS = '';
          this.filterList.SeedSizeList.forEach(x => {
            strSS = strSS + x + ', ';
          });
          this.filterValueList.push('Seed Size : ' + strSS.substr(0, strSS.length - 2));

          selectedIds = '';
          this.seedsizeMasterList.forEach(x => {
            if (this.filterList.SeedSizeList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.seedSize = selectedIds;
        }
        else {
          this.filter.seedSize = null;
        }

        // Package Size
        if (this.filterList.PackageSizeList && this.filterList.PackageSizeList.length > 0) {
          let strPS = '';
          this.filterList.PackageSizeList.forEach(x => {
            strPS = strPS + x + ', ';
          });
          this.filterValueList.push('Package Size : ' + strPS.substr(0, strPS.length - 2));
          selectedIds = '';
          this.packagesizeMasterList.forEach(x => {
            if (this.filterList.PackageSizeList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.packageSize = selectedIds;
        }
        else {
          this.filter.packageSize = null;
        }

        // Treatment
        if (this.filterList.TreatmentList && this.filterList.TreatmentList.length > 0) {
          let strTreat = '';
          this.filterList.TreatmentList.forEach(x => {
            strTreat = strTreat + x + ', ';
          });
          this.filterValueList.push('Treatment : ' + strTreat.substr(0, strTreat.length - 2));

          selectedIds = '';
          this.treatmentMasterList.forEach(x => {
            if (this.filterList.TreatmentList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.treatment = selectedIds;
        }
        else {
          this.filter.treatment = null;
        }

        // text Account No
        if (this.filterList.TxtAccountNo && this.filterList.TxtAccountNo != '') {
          this.filterValueList.push('Account No : ' + this.filterList.TxtAccountNo);
          this.filter.account = this.filterList.TxtAccountNo;
        }
        else if (this.filterList.AccountNo && this.filterList.AccountNo.length > 0) {
          let strAct = '';
          this.filterList.AccountNo.forEach(x => {
            strAct = strAct + x + ', ';
          });
          this.filterValueList.push('Account No : ' + strAct.substr(0, strAct.length - 2));

          // selectedIds = '';
          // this.accountNoList.forEach(x => {
          //  if (this.filterList.AccountNo.indexOf(x.accountNumber) > -1) {
          //    selectedIds = selectedIds + x.accountNumber + ',';
          //  }
          // })
          this.filter.account = strAct;
        }
        else {
          this.filter.account = null;
        }

        // Account Name
        if (this.filterList.AccountName && this.filterList.AccountName != '') {
          this.filterValueList.push('Account Name : ' + this.filterList.AccountName);
          this.filter.accountName = this.filterList.AccountName;
        }
        else {
          this.filter.accountName = null;
        }
        // Parent Account No
        if (this.filterList.ParentNo && this.filterList.ParentNo != '') {
          this.filterValueList.push('Parent Account No : ' + this.filterList.ParentNo);
          this.filter.parentNo = this.filterList.ParentNo;
        }
        else {
          this.filter.parentNo = null;
        }

        // Item No
        // Marketing Brand
        if (this.filterList.ItemNoList && this.filterList.ItemNoList.length > 0) {
          let strINO = '';
          this.filterList.ItemNoList.forEach(x => {
            strINO = strINO + x + ', ';
          });
          this.filterValueList.push('Item Number : ' + strINO.substr(0, strINO.length - 2));

          selectedIds = '';
          this.orderNoList.forEach(x => {
            if (this.filterList.ItemNoList.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.itemNo = selectedIds;
        }
        else {
          this.filter.itemNo = null;
        }

        // User Id
        if (this.filterList.UserId && this.filterList.UserId.length > 0) {
          let strus = '';
          this.filterList.UserId.forEach(x => {
            strus = strus + x + ', ';
          });
          this.filterValueList.push('User Id : ' + strus.substr(0, strus.length - 2));
          var sessionData = this.validateEvolveData.resultData.find(x => x.userIdCompanyCode == this.headerCompany);
          if (!sessionData.evolveAccountRestriction) {
            this.searchTypeList = ['Product Name', 'Marketing Brand', 'Product Line', 'Seed Size', 'Package Size',
              'Treatment', 'Item Number', 'Parent Account No', 'Account No', 'Account Name', 'WFU Employee', 'City', 'State/ Province', 'Order Type', 'Order No'];
          }

          selectedIds = '';
          this.userIdList.forEach(x => {
            if (this.filterList.UserId.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.userID = selectedIds;
        } else {
          this.filter.userID = null;
        }

        // Order No
        if (this.filterList.OrderId && this.filterList.OrderId != '') {
          this.filterValueList.push('Order No : ' + this.filterList.OrderId);
          this.filter.orderNumber = this.filterList.OrderId;
        } else {
          this.filter.orderNumber = null;
        }

        // City
        if (this.filterList.City && this.filterList.City != '') {
          this.filterValueList.push('City : ' + this.filterList.City);
          this.filter.city = this.filterList.City;
        } else {
          this.filter.city = null;
        }

        // State
        if (this.filterList.State && this.filterList.State.length > 0) {
          let strSt = '';
          this.filterList.State.forEach(x => {
            strSt = strSt + x + ', ';
          });
          this.filterValueList.push('State : ' + strSt.substr(0, strSt.length - 2));

          selectedIds = '';
          this.stateMasterList.forEach(x => {
            if (this.filterList.State.indexOf(x.value) > -1) {
              selectedIds = selectedIds + x.id + ',';
            }
          });
          this.filter.state = selectedIds;
        } else {
          this.filter.state = null;
        }

        // Order Type
        if (this.filterList.OrderTypeList && this.filterList.OrderTypeList != '') {
          this.filterValueList.push('Order Type : ' + this.filterList.OrderTypeList);
          this.filter.orderType = this.filterList.OrderTypeList;
        } else {
          this.filter.orderType = null;
        }
      }
    }

    if (this.filterList && (this.filterList.Brand != null && this.filterList.Brand !== '') ||
      (this.filterList.MarketingBrandList && this.filterList.MarketingBrandList.length > 0) ||
      (this.filterList.DistrictList && this.filterList.DistrictList.length > 0) ||
      (this.filterList.ProductLineList && this.filterList.ProductLineList.length > 0) ||
      (this.filterList.SeedSizeList && this.filterList.SeedSizeList.length > 0) ||
      (this.filterList.OrderTypeList != null && this.filterList.OrderTypeList !== '') ||
      (this.filterList.PackageSizeList && this.filterList.PackageSizeList.length > 0) ||
      (this.filterList.TreatmentList && this.filterList.TreatmentList.length > 0) ||
      (this.filterList.ParentNo != null && this.filterList.ParentNo != '') ||
      (this.filterList.TxtAccountNo != null && this.filterList.TxtAccountNo !== '') ||
      (this.filterList.AccountNo && this.filterList.AccountNo.length > 0) ||
      (this.filterList.AccountName != null && this.filterList.AccountName !== '') ||
      (this.filterList.UserId && this.filterList.UserId.length > 0) ||
      (this.filterList.OrderId != null && this.filterList.OrderId !== '') ||
      (this.filterList.City != null && this.filterList.City !== '') ||
      (this.filterList.State && this.filterList.State.length > 0) ||
      (this.filterList.ItemNoList && this.filterList.ItemNoList.length > 0)) {
      // TO Do Get data and bind in grid
    }

    this.enableDisableSearch();
    this.previousSelectedValue = this.selectedValue;
    this.searchValue = '';
    this.partialSearchValue = '';
    this.setFilterTypeList();
  }

  // get filter data
  getFilterData() {
    this.keepFilter();
    if (!this.validateInputText()) {
      return false;
    }

    // enable loader
    this.loaderService.setLoaderStatus(true);

    // get filter data from database

    this.subscription.push(this.quickSearchOrderService.getQuickSearchData(this.filter)
      .subscribe(result => {
        if (result) {
          const data = result as QuickSearchData[];
          // set data in Table datasorece
          this.bodyDS = data as any[];
        }

        // set Table Paginator Data Source
        if (this.bodyDS) {
          this.length = this.bodyDS.length;
          this.setPaginatorDS();
          this.paginator.firstPage();
        }
        // disable loader
        this.loaderService.setLoaderStatus(false);
      }, error => { this.loaderService.setLoaderStatus(false); LolLoggerService.error(error); }));
  }

  // set paginator on change
  setPaginatorDS() {
    const recordToSkip = this.pageSize * this.pageIndex;
    this.paginatorDS = this.bodyDS.slice(recordToSkip, recordToSkip + this.pageSize);
  }

  // Set MatPaginator Inputs on paginator change
  onPaginatorChange(e: PageEvent) {
    this.pageIndex = e.pageIndex;
    this.pageSize = e.pageSize;
    this.setPaginatorDS();
  }

  // Table sorting
  sortData(sort: Sort) {
    const data = this.bodyDS.slice();

    if (!sort.active || sort.direction === '') {
      return;
    }

    this.bodyDS = data.sort((a, b) => {
      const isAsc = sort.direction === 'asc';
      return compare(a[sort.active], b[sort.active], isAsc);
    });

    this.setPaginatorDS();
  }

  // Export data from grid data
  onExportBtnClick() {
    const excelData = [];
    this.loaderService.setLoaderStatus(true);

    setTimeout(x => {
      if (this.bodyDS && this.bodyDS.length > 0) {
        const headerText = this.headerDS.map(x => this.originalDisplayedColumns.find(y => y.columnfield === x.columnfield).headertxt);

        this.bodyDS.forEach(x => {
          const exportData = new Map();
          headerText.forEach(y => {
            switch (y) {
              case 'Order Number': {
                exportData.set(y, x.orderNumber)
                break;
              }
              case 'Order Type': {
                exportData.set(y, x.orderType)
                break;
              }
              case 'Item Number': {
                exportData.set(y, x.itemNumber)
                break;
              }
              case 'GTIN': {
                exportData.set(y, x.gtin)
                break;
              }
              case 'Product Name': {
                exportData.set(y, x.brand)
                break;
              }
              case 'Seed Size': {
                exportData.set(y, x.seedSize)
                break;
              }
              case 'Treatment': {
                exportData.set(y, x.treatment)
                break;
              }
              case 'Package Size': {
                exportData.set(y, x.packageSize)
                break;
              }
              case 'Long/(Short)': {
                exportData.set(y, (x.orderType === 'Dealer Order') ? parseFloat(this.commonService.getFormatedNumber(x.longShort, false)) : '')
                break;
              }
              case 'MDB': {
                exportData.set(y, (x.orderType === 'Dealer Order') ? parseFloat(this.commonService.getFormatedNumber(x.mdbUnits, false)) : '')
                break;
              }
              case 'Equiv Units(BG)': {
                exportData.set(y, parseFloat(this.commonService.getFormatedNumber(x.quantity, false)))
                break;
              }
              case 'In Progress(Soft+Hard)': {
                exportData.set(y, (x.orderType === 'Dealer Order') ? x.inProgressQty : '')
                break;
              }
              case 'Shipped/Invoiced': {
                exportData.set(y, (x.orderType === 'Dealer Order') ? x.shippedInvoicedQty : '')
                break;
              }
              case 'Left to Process': {
                exportData.set(y, (x.orderType === 'Dealer Order') ? x.leftToProcess : '')
                break;
              }
              case 'Left to Invoice': {
                exportData.set(y, (x.orderType === 'Dealer Order') ? x.leftToInvoiced : '')
                break;
              }
              //case 'EA Units': {
              //  exportData.set(y, (x.orderType === 'Dealer Order') ? x.eaUnits : '')
              //  break;
              //}
              //case 'EA Units Remaining': {
              //  exportData.set(y, (x.orderType === 'Dealer Order') ? x.eaModifiableUnits : '')
              //  break;
              //}
              case 'Desired Delivery Date': {
                exportData.set(y, x.desiredDeliveryDate)
                break;
              }
              case 'Grower Business Name': {
                exportData.set(y, x.growerBusinessName)
                break;
              }
              case 'Grower Name': {
                exportData.set(y, x.growerName)
                break;
              }
              case 'GLN': {
                exportData.set(y, x.gln)
                break;
              }
              case 'Parent Account': {
                exportData.set(y, x.parentNo)
                break;
              }
              case 'Account': {
                exportData.set(y, x.accountNumber)
                break;
              }
              case 'Account Name': {
                exportData.set(y, x.accountName)
                break;
              }
              case 'Account City': {
                exportData.set(y, x.city)
                break;
              }
              case 'Account State': {
                exportData.set(y, x.state)
                break;
              }
              case 'Account Zip': {
                exportData.set(y, x.zipCode)
                break;
              }
              case 'Marketing Brand': {
                exportData.set(y, x.marketingBrand)
                break;
              }
              case 'Product Line': {
                exportData.set(y, x.productLine)
                break;
              }
              case 'Seller Name': {
                exportData.set(y, x.sellerName)
                break;
              }
              case this.impDisplayName: {
                exportData.set(y, x.implAccountName)
                break;
              }
              case 'Account Manager': {
                exportData.set(y, x.actMgrAccountName)
                break;
              }
              case 'Sales Enablement/CDS': {
                exportData.set(y, x.salesEnabAccountName)
                break;
              }
              case 'ASM/BU Lead': {
                exportData.set(y, x.asmLeadAccountName)
                break;
              }
              case 'SE/CDS Lead': {
                exportData.set(y, x.secdsLeadAccountName)
                break;
              }
              case 'Seed Execution Lead': {
                exportData.set(y, x.selAccountName)
                break;
              }
              default: {
                break;
              }
            }
          });

          const obj = this.autoConvertMapToObject(exportData);

          excelData.push(
            obj
          );
        });
        this.excelService.exportExcel(excelData, 'OrderDetailReport');
      }
      this.loaderService.setLoaderStatus(false);
    }, 100);
  }

  private autoConvertMapToObject = (map) => {
    const obj = {};
    for (const item of [...map]) {
      const [
        key,
        value
      ] = item;
      obj[key] = value;
    }
    return obj;
  }

  // emit row click event
  redirectToOrder(e: any, rowData: any) {
    let orderType, accountNo, orderId;
    orderType = rowData.orderType;
    accountNo = rowData.accountNumber;
    orderId = rowData.orderId;

    if (rowData.clickable && orderType == 'Dealer Order' && accountNo != 0 && orderId != 0) {
      this.onNavigate('/orders/dealer-order-view' + '/0' + '/' + orderId + '/' + accountNo);
    }
    else if (rowData.clickable && orderType == 'Grower Order' && accountNo != 0 && orderId != 0) {
      this.onNavigate('/orders/grower-order-detail' + '/0' + '/' + orderId);
    }
  }

  // Navigate
  onNavigate(url) {
    window.open(url, '_blank');
  }

  // Added ngAfterViewInit to calculate height after view loading
  ngAfterViewInit() {
    // Set Dynamic Height of Panels
    this.setAccountTableHeight();
  }

  // Set Account Table Height
  setAccountTableHeight() {
    setTimeout(function () {
      const tableHeight = window.innerHeight - $('.quickSearchTopFilter').outerHeight() - $('.tableTopSec').outerHeight() - 200;
      $('.tableComponentOuter').css('max-height', tableHeight + 'px');
    }, 100);
  }

  @HostListener('window:resize', ['$event']) onresize(event) {
    this.setAccountTableHeight();
  }

  // Set Filter Type list on user Id and district selection
  setFilterTypeList() {
    this.filter.district;

    this.searchTypeList = ['Product Name', 'Marketing Brand', 'Product Line', 'Seed Size', 'Package Size',
      'Treatment', 'Item Number', 'Parent Account No', 'Account No', 'Account Name', 'WFU Employee', 'City', 'State/ Province', 'User ID', 'Order Type', 'Order No'];

    if (this.filter.district) {
      this.searchTypeList = this.searchTypeList.filter(x => x != 'User ID');
    }
    if (this.filter.userID) {
      this.searchTypeList = this.searchTypeList.filter(x => x != 'WFU Employee');
    }
  }

  // Search the account details on shipto / Deliverto dropdown
  filterSearchFn(term: string, item: any) {
    term = term.toLocaleLowerCase();
    return item.accountName.toLocaleLowerCase().indexOf(term) > -1
      || item.accountNumber.toString().indexOf(term) > -1
      || item.address1.toLocaleLowerCase().indexOf(term) > -1
      || item.city.toLocaleLowerCase().indexOf(term) > -1
      || item.state.toLocaleLowerCase().indexOf(term) > -1
      || item.zipCode.toLocaleLowerCase().indexOf(term) > -1;
  }
}

// Model and function

function compare(a: number | string, b: number | string, isAsc: boolean) {
  return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
}

export class commonDDL {
  accounts: any[];
  states: any[];
  userId: any[];
  distDSM: any[];
  marketingBrand: any[];
}

export class QuickSearchFilter {
  companyCode: string;
  cropYear: number;
  productName: string;
  marketingBrand: string;
  productLine: string;
  seedSize: string;
  packageSize: string;
  treatment: string;
  parentNo: number;
  district: string;
  account: string;
  userID: string;
  accountName: string;
  orderNumber: string;
  city: string;
  state: string;
  userRole: string;
  orderType: string;
  itemNo: string;
}

export class QuickSearchData {
  orderId: number;
  orderType: string;
  itemNumber: string;
  itemDescription: string;
  quantity: number;
  inProgressQty: number;
  shippedInvoicedQty: number;
  leftToProcess: number;
  leftToInvoiced: number;
  eaUnits: number;
  eaModifiableUnits: number;
  longShort: number;
  desiredDeliveryDate: Date;
  growerBusinessName: string;
  growerName: string;
  accountNumber: number;
  city: string;
  state: string;
  seedSize: string;
  treatment: string;
  parentNo: number;
  marketingBrand: string;
  packageSize: string;
  b2B: boolean;
  clickable: boolean;
  dsm: number;
  rsd: number;
}
